<template>
  <div class="container">
    <h1>
      <font-awesome-icon icon="home" /> Home - <a href="#">Registeration</a>
    </h1>
  
    <div class="row">
     
  <div class="col-md-3">
<img  src="./../assets/Registeration.png" width="350" alt="Circle image"/>
  </div>
  <div class="col-md-9 pt-4">
  <div class="panal mt-20" style="
    margin-left: -48px;
">
        
   <div class="panal-body row pl-5">
<h1 class="w-100">Nice message Title</h1>
<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's. 
</p>

</div>
        </div>

     
      </div>

 <div class="col-md-12 pt-4">
  <div class="panal" >
        <div class="panal-header">Filter Registeration</div> 
   <div class="panal-body row pl-5">

<div class="row w-100">
                  <h6 class="col-md-12">Levels</h6>
                  <div class="col-md-2">Student level</div>
                  <div class="col-md-9">
                  <b-form-select v-model="LevelNameinsert" class="">
                    <b-form-select-option
                      v-for="Level in LevelName"
                      v-bind:key="Level.serial"
                      :value="Level.serial"
                      >{{ Level.StageName }}
                      </b-form-select-option>
                  </b-form-select>
                </div></div>

                <hr class="w-100" />
                <div class="row w-100">
                  <h6 class="col-md-12">Specialization</h6>
                  <div class="col-md-2">Student Specialization</div>
                  <div class="col-md-9">
                  <b-form-select
                    v-model="Specializationinsert"
                    class="mb-3"
                  >
                    <!-- <b-form-select-option :value="null">Please select an option</b-form-select-option> -->
                    <b-form-select-option
                      v-for="spac in Specialization"
                      v-bind:key="spac.SpecializationID"
                      :value="spac.SpecializationID"
                      >{{ spac.SpecializationNameEN }}</b-form-select-option
                    >
                  </b-form-select>
                </div>
                </div>

                <hr class="w-100" />
                <div class="row w-100">
                  <h6 class="col-md-12">Courses</h6>
                 
                    <b-col class="col-md-2 mt-1">Course Code</b-col>

                     <b-col class="col-md-3 mt-1">
                    <b-form-input
                      v-model="courseCode"
                      class=""
                      placeholder="Enter course code"
                    ></b-form-input>
                    </b-col>
                    <b-col class="col-md-2 mt-1">Course Name</b-col>
                    <b-form-input
                      v-model="courseName"
                      class="col-md-3"
                      placeholder="Enter course Name"
                    ></b-form-input>
                 
                </div>

                  <div class="text-center col-md-12 ">
            <button
              class="mt-3 btn btn-primary"
              block
              @click="$bvModal.hide('modal-lg'), filteredCourses2()"
              >Search</button
            >
          </div>




</div>
        </div>


      </div>





    </div>

   

   
  </div>
</template>
<script>
import studentData from "../services/student/studentDataServices";
export default {
  name: "Profile",
  data() {
    return {
   
    };
  },

  methods: {
            logOut() {
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
    },


    filteredCourses2(){

        //this.IsSelected = false;
          this.isLoading = true;

        //   if(this.FilterCourses === "All") { 

        //  //this.IsSelected = false;
        //   } else 
        //   {
        // // this.IsSelected = true;
        //   }

             SelectSubject.GetStudentRegistrationCourses(this.currenUser.StudentID, this.currenUser.FacultyID_Enrollment,
                             this.currenUser.SpecializationID, this.currenUser.LevelID, this.courseCode, this.courseName, 3 ).then( (Response) => {
           this.isLoading = false ;
               this.selectSubjectList = Response.data
                this.empty =false
                                           
                          
                  // console.log('Courses => ', this.Courses);
                  // console.log('this.levels => ', this.levels);
           }, error => {
           
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
        this.courseCode='';
        this.courseName='';
        this.LevelNameinsert='0';
        this.IsSelected = false;
        this.Specializationinsert='0';

        }, 



  },

  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },

  mounted() {

 


    
    studentData.GetStudentData(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.personalData = Response.data.StudentData;
        // eslint-disable-next-line no-console
         console.log(this.personalData);

      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status);

        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    ),
      //this.currenUser.StudentID
      // studentData.GetStudentActivityGrading(25096, 366, 3).then(
      //   (Response) => {
      //     this.isLoading = false;
      //     this.Grading = Response.data;
      //     // eslint-disable-next-line no-console
      //     console.log(this.Grading);
      //   },
      //   (error) => {
      //     // eslint-disable-next-line no-console
      //     console.log(error.response.status);

      //     this.message =
      //       (error.response &&
      //         error.response.data &&
      //         error.response.data.Message) ||
      //       error.message ||
      //       error.toString();

      //     if (error.response.status == 404) this.message = "";
      //   }
      // ),
      //this.currenUser.StudentID // 566
      studentData.getStudentScheduale(this.currenUser.StudentID).then(
        (Response) => {
          this.isLoading = false;
          this.courses = Response.data;
          // eslint-disable-next-line no-console
          // console.log(this.Grading);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );

      
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.img-profile{
   border-radius: 50%;
   width:180px;
   border:2px solid #285475;
}

.img-user {
      border-radius: 50%;
    width: 100px;
    height: 100px;
    border: 2px dotted #ff8600;
    background: #f2f2f2;
    text-align: center;
    vertical-align: middle;
    padding: 21px;
    float: left;
    margin: 10px;
    font-size: 34px;
}

.active2 {
   background: #285475 !important;
   color:#fff;
}
.title{
  color:#285475;
  font-weight: 700;
  text-align: center;
}
.changeImg{
  margin-top: -40px;
    position: absolute;
    left: 180px;
}
.changeImg a{
  color:#ff8600;
}
.profileData{
  border: 1px dotted #646464;
  color:#285475;
  padding: 3px 10px;
  font-weight: 700;
}

.profileData2{
  border: 1px dotted #646464;
  color:#ff8600;
  padding: 3px 10px;
  font-weight: 700;
}
.clearfix{
 clear: both;
  display: table;
}
.line1{
     border-top: 1px dotted #285475;
    border-bottom: 1px dotted #285475;
    height: 10px;
    width: 114px;
    float: left;
    margin-top: 57px;
}
</style>
